import Enumeration from 'Lib/utilities/Enumeration';

const ApplicationSections = new Enumeration([
    { id: 1, name: 'ApplyingFor' },
    { id: 2, name: 'LeaseInfo' },
    { id: 3, name: 'PersonalInfo' },
    { id: 4, name: 'EmergencyContact', pathName: 'emergencyContacts' },
    { id: 5, name: 'References', pathName: 'references' },
    { id: 6, name: 'Vehicles', pathName: 'vehicles' },
    { id: 7, name: 'Occupants', pathName: 'occupants' },
    { id: 8, name: 'Pets', pathName: 'pets' },
    { id: 9, name: 'CurrentAddress' },
    { id: 10, name: 'AddressHistory', pathName: 'addresses' },
    { id: 11, name: 'EmploymentHistory', pathName: 'employers' },
    { id: 12, name: 'Income', pathName: 'incomes' },
    { id: 13, name: 'BankAccounts', pathName: 'banks' },
    { id: 14, name: 'CreditCards', pathName: 'creditCards' },
    { id: 15, name: 'Assistance' },
    { id: 16, name: 'Questions' },
    { id: 17, name: 'Terms' },
    { id: 18, name: 'Documents', pathName: 'documents' },
    { id: 19, name: 'ReviewSign' },
    { id: 20, name: 'Pay' },
    { id: 21, name: 'ApplicationInstructions' },
    { id: 22, name: 'Addenda' },
    { id: 23, name: 'IncomeVerification' },
    { id: 24, name: 'IdentityVerification' },
    { id: 25, name: 'IncomeVerificationDocuments' },
    { id: 26, name: 'IdentityVerificationDocuments' }
]);

export default ApplicationSections;
